export default {"src":"/_next/static/media/0x111111111117dc0aa78b770fa6a738034120c302.894ef55d.svg","height":122,"width":122,"blurWidth":0,"blurHeight":0};